import type { SearchHarEntryResult } from './ChatFindingSearchProvider';

const readStringField = (
  record: Record<string, unknown>,
  key: string,
): string | undefined => {
  const value = record[key];
  return typeof value === 'string' ? value : undefined;
};

const readNumberField = (
  record: Record<string, unknown>,
  key: string,
): number | undefined => {
  const value = record[key];
  return typeof value === 'number' ? value : undefined;
};

export const toSearchHarEntryResult = (entry: {
  id: string;
  request: unknown;
  response: unknown;
  createdAt?: Date | string;
}): SearchHarEntryResult => {
  const request =
    entry.request && typeof entry.request === 'object'
      ? (entry.request as Record<string, unknown>)
      : {};
  const response =
    entry.response && typeof entry.response === 'object'
      ? (entry.response as Record<string, unknown>)
      : {};

  return {
    id: entry.id,
    method: readStringField(request, 'method'),
    url: readStringField(request, 'url'),
    status: readNumberField(response, 'status'),
    createdAt: entry.createdAt
      ? new Date(entry.createdAt).toISOString()
      : undefined,
  };
};
